import React, { memo } from 'react';
import { oneOfType, array, object } from 'prop-types';
const DefaultLayout = ({
  segment,
  criticalInfo
}) => /*#__PURE__*/React.createElement(React.Fragment, null, segment, /*#__PURE__*/React.createElement("div", null, criticalInfo));
DefaultLayout.propTypes = {
  segment: oneOfType([array, object]).isRequired,
  criticalInfo: object
};
export default /*#__PURE__*/memo(DefaultLayout);